import { Link } from 'react-router-dom';
import type { ArticleData } from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

const articleOrder = [
  'sicurezza-acquisti',
  'qc-photo-guida',
  'pagamenti-sicuri',
  'confronto-agent',
  'analisi-prezzi',
  'alternative-itaobuy',
  'strategie-itaobuy',
  'risparmio-itaobuy',
  'ottimizzazione-ordini',
];

const articleCardImages: Record<string, string> = {
  'sicurezza-acquisti': 'https://readdy.ai/api/search-image?query=Closeup%20of%20secure%20shopping%20concept%20with%20padlock%20beside%20fashion%20purchase%20receipt%20on%20warm%20walnut%20desk%2C%20soft%20golden%20morning%20light%20through%20sheer%20drapes%2C%20sophisticated%20security%20editorial%20aesthetic%2C%20rich%20amber%20and%20mahogany%20tones%2C%20intimate%20trustworthy%20atmosphere%2C%20no%20text&width=500&height=360&seq=card-sicurezza&orientation=landscape',
  'qc-photo-guida': 'https://readdy.ai/api/search-image?query=Professional%20camera%20beside%20product%20inspection%20setup%20with%20sneakers%20and%20measuring%20tools%20on%20clean%20white%20studio%20surface%2C%20bright%20crisp%20overhead%20lighting%2C%20modern%20quality%20control%20editorial%20photography%2C%20clean%20precise%20composition%2C%20subtle%20gray%20and%20white%20palette%20with%20product%20color%20pop%2C%20no%20text&width=500&height=360&seq=card-qcphoto&orientation=landscape',
  'pagamenti-sicuri': 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20secure%20payment%20interface%20beside%20designer%20wallet%20on%20elegant%20marble%20surface%2C%20soft%20warm%20cafe%20lighting%2C%20modern%20fintech%20lifestyle%20editorial%2C%20sophisticated%20trustworthy%20aesthetic%2C%20warm%20cream%20and%20gold%20tones%2C%20screen%20content%20not%20visible%2C%20no%20text&width=500&height=360&seq=card-pagamenti&orientation=landscape',
  'confronto-agent': 'https://readdy.ai/api/search-image?query=Two%20shipping%20boxes%20with%20different%20carrier%20labels%20side%20by%20side%20on%20industrial%20concrete%20floor%2C%20dramatic%20side%20lighting%20from%20warehouse%20window%2C%20logistics%20comparison%20concept%20editorial%2C%20authentic%20industrial%20aesthetic%2C%20cool%20gray%20and%20warm%20brown%20contrast%2C%20no%20text%20or%20visible%20brand%20names&width=500&height=360&seq=card-confronto&orientation=landscape',
  'analisi-prezzi': 'https://readdy.ai/api/search-image?query=Vintage%20calculator%20beside%20fashion%20price%20tags%20and%20elegant%20accessories%20on%20rich%20mahogany%20desk%20surface%2C%20warm%20banker%20lamp%20light%20creating%20intimate%20study%20atmosphere%2C%20sophisticated%20financial%20editorial%20aesthetic%2C%20deep%20cognac%20and%20brass%20tones%2C%20no%20visible%20numbers%2C%20no%20text&width=500&height=360&seq=card-prezzi&orientation=landscape',
  'alternative-itaobuy': 'https://readdy.ai/api/search-image?query=Two%20different%20fashion%20catalogs%20with%20sticky%20note%20bookmarks%20side%20by%20side%20on%20warm%20oak%20table%2C%20soft%20diffused%20library%20light%2C%20thoughtful%20comparison%20editorial%20concept%2C%20intellectual%20European%20aesthetic%2C%20warm%20paper%20and%20wood%20tones%2C%20no%20text&width=500&height=360&seq=card-alternative&orientation=landscape',
  'strategie-itaobuy': 'https://readdy.ai/api/search-image?query=Strategic%20planning%20board%20with%20fashion%20mood%20board%20pins%20and%20fabric%20samples%20on%20creative%20studio%20wall%2C%20bright%20loft%20window%20light%2C%20modern%20creative%20director%20workspace%20aesthetic%2C%20inspiring%20organized%20chaos%2C%20warm%20terracotta%20and%20sage%20tones%2C%20no%20text%20or%20logos&width=500&height=360&seq=card-strategie&orientation=landscape',
  'risparmio-itaobuy': 'https://readdy.ai/api/search-image?query=Glass%20savings%20jar%20filled%20with%20coins%20beside%20folded%20fashion%20items%20on%20warm%20rustic%20wooden%20shelf%2C%20gentle%20afternoon%20sunlight%20through%20window%2C%20cozy%20domestic%20savings%20concept%20editorial%2C%20warm%20inviting%20atmosphere%2C%20terracotta%20and%20honey%20tones%2C%20no%20text&width=500&height=360&seq=card-risparmio&orientation=landscape',
  'ottimizzazione-ordini': 'https://readdy.ai/api/search-image?query=Organized%20shipping%20station%20with%20labeled%20boxes%20measuring%20tape%20and%20checklist%20clipboard%20on%20clean%20industrial%20workbench%2C%20bright%20efficient%20studio%20lighting%2C%20modern%20logistics%20editorial%20aesthetic%2C%20systematic%20clean%20composition%2C%20warm%20gray%20and%20kraft%20paper%20tones%2C%20no%20text%20visible&width=500&height=360&seq=card-ottimizza&orientation=landscape',
};

const categoryLabels: Record<string, string> = {
  'sicurezza-acquisti': 'Sicurezza',
  'qc-photo-guida': 'Sicurezza',
  'pagamenti-sicuri': 'Sicurezza',
  'confronto-agent': 'Confronti',
  'analisi-prezzi': 'Confronti',
  'alternative-itaobuy': 'Confronti',
  'strategie-itaobuy': 'Avanzati',
  'risparmio-itaobuy': 'Avanzati',
  'ottimizzazione-ordini': 'Avanzati',
};

const categoryColors: Record<string, string> = {
  'Sicurezza': 'bg-secondary-100 text-secondary-700',
  'Confronti': 'bg-accent-100 text-accent-700',
  'Avanzati': 'bg-primary-100 text-primary-700',
};

export default function MoreArticlesGrid() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-12">
          <span className="text-xs font-heading italic text-accent-600">Ultime Guide</span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-2">
            Articoli SEO
            <br />
            <span className="font-heading italic font-normal text-foreground-600">per Ogni Esigenza</span>
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-lg">
            Approfondimenti dettagliati su sicurezza, confronti e strategie avanzate per massimizzare la tua esperienza con Itaobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleOrder.map((slug) => {
            const article: ArticleData = allArticles[slug];
            const cat = categoryLabels[slug];
            return (
              <Link
                key={slug}
                to={`/articoli/${slug}`}
                className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all hover:scale-[1.01]"
              >
                <div className="aspect-[5/3] overflow-hidden">
                  <img
                    src={articleCardImages[slug]}
                    alt={article.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${categoryColors[cat] || 'bg-secondary-100 text-secondary-700'}`}>
                      {cat}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readingTime}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
                    {article.subtitle}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articoli/guida-completa-itaobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium rounded-full bg-secondary-100 text-foreground-700 hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            Vedi la Guida Completa
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            itemListElement: articleOrder.map((slug, idx) => ({
              '@type': 'ListItem',
              position: idx + 1,
              item: {
                '@type': 'Article',
                name: allArticles[slug].title,
                url: `https://itaobuyspread.pics/articoli/${slug}`,
              },
            })),
          }),
        }}
      />
    </section>
  );
}